export default __webpack_public_path__ + "static/media/Thumbnail4.68161c94.jpg";